<div class="list-container">
  @for (c of cardList; track c.ItemFlavorId) {
    <div class="card-spacing">
      <app-application-card
        [userID]="userID"
        [card]="c"
        (cardRequestEvent)="handleCardEvent($event)"
        [canUseOpenButton]="canUseOpenButton"
      ></app-application-card>
    </div>
  }
  @for (l of localAppList; track l.AppName) {
    <div class="card-spacing">
      <app-local-app-card [userID]="userID" [card]="l"></app-local-app-card>
    </div>
  }
</div>
